import React from 'react';

import LinkWithAuthorization from '@appComponents/LinkWithAuthorization';
import {renderModalError} from '@utils/forms';
import * as RESOURCES from '@constants/resources';
import * as CONST from '@constants/variables';
import {convertToInt} from '@utils/helpers';

export const linkToRightScope = (contentCount, propertyLicenceId, rightScopeId = null) => {
    let link = {
        name: 'propertyLicences.content.index',
        params: {id: convertToInt(propertyLicenceId)},
    };

    if (rightScopeId) {
        link = {
            name: 'propertyLicences.rightsScopes.editGeneralInformation',
            params: {
                id: convertToInt(propertyLicenceId),
                rightsScopeId: convertToInt(rightScopeId),
            },
        };
    }

    return (
        <LinkWithAuthorization
            resources={RESOURCES.PROPERTY_LICENCE}
            privileges={CONST.SECURITY_PRIVILEGES_UPDATE}
            link={link}
        >
            Show all ({contentCount} more)
        </LinkWithAuthorization>
    );
};

export const renderPropertyLicenceModalError = () => (
    renderModalError('Property licence', '/property-licences')
);
renderPropertyLicenceModalError.displayName = 'renderPropertyLicenceModalError';

export const getPreparedBasicDataForEntity = (propertyLicence) => ({
    name: 'propertyLicence',
    data: {
        id: propertyLicence.id,
        name: propertyLicence.name,
        content_category_id: propertyLicence.content_category ? propertyLicence.content_category.id : null,
        stage_category_id: propertyLicence.stage_category?.id ?? null,
        content_tier_id: propertyLicence.content_tier.id,
        property_licence_type_id: propertyLicence.property_licence_type.id,
        sport_id: propertyLicence.sport ? propertyLicence.sport.id : null,
        has_accreditation: propertyLicence.has_accreditation,
        accreditation_contact_person_id: propertyLicence.accreditation_contact_person
            ? propertyLicence.accreditation_contact_person.id
            : null,
        is_archived: propertyLicence.is_archived,
    },
});
